import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateTaxSaga } from "src/store/tax/saga";
import { TaxDetailDto } from "src/store/tax/type";
import * as Yup from "yup";

const TaxEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: TaxDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Tax.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          Value: data.Value,
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Value: Yup.number().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Tax.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "Value",
            label: t("Tax.Value").toString(),
          },
        ]}
        onSubmit={(values) => {
          dispatch(
            updateTaxSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
      />
    </React.Fragment>
  );
};
export default TaxEditForm;
